import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListCouponCodeCategories from '../../components/coupon-codes/list-coupon-code-categories.component';

const CouponCodeCategoriesView = () => {
  const pageTitle = 'Manage Users / Promo Code Categories';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListCouponCodeCategories />
    </AppLayout>
  );
};

export default CouponCodeCategoriesView;
